import { cn } from "@/utils/utils";

interface GradientProgressBarProps {
  percentage: number;
  className?: string;
}

export function GradientProgressBar({
  percentage,
  className,
}: GradientProgressBarProps) {
  return (
    <div
      className={cn(
        "relative h-[7px] w-[100px] overflow-hidden rounded-full bg-[#f5f5f6]",
        className,
      )}
    >
      <div
        className="absolute left-0 top-0 h-full overflow-hidden rounded-full bg-[#FDBD9C] transition-all"
        style={{ width: `${percentage}%` }}
      >
        <div className="absolute left-0 top-0 h-[7px] w-full rounded-full bg-brand" />
      </div>
    </div>
  );
}
